import type { FC } from 'react';
import type { PickProps } from '@/ui/types/types';
import clsx from 'clsx';
import styles from './Indicator.module.css';

type Props = {
    status?: 'success';
    size?: number;
} & PickProps<'div', 'ref'>;

export const Indicator: FC<Props> = ({ status = 'success', size = 8, ...props }) => (
    <div
        className={clsx(styles.indicator, styles[`status-${status}`])}
        style={{
            width: `${size}px`,
            height: `${size}px`
        }}
        {...props}
    />
);
